import { jwtDecode } from 'jwt-decode';

export const storeToken = (token) => localStorage.setItem('access', token);
export const getToken = () => localStorage.getItem('access');
export const removeToken = () => localStorage.removeItem('access');
export const decodeToken = () => {
    const token = getToken();
    return token ? jwtDecode(token) : null;
};
